module.exports = __webpack_public_path__ + "img/disclaimer.1c330f30.svg";